import React, { useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridRowSelectionModel,
  GridSortModel,
  GridValueFormatterParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import "./styles.scss";
import "./styles.scss";
import { ACHType } from "../../types/genericType";
import { Box, Typography } from "@mui/material";
import { convertToLocalWithoutUTC } from "../../utils/dateFormat";
import { formatDollar } from "../../utils/utils";

type ACHTableProps = {
  data: Array<ACHType>;
  search: string;
  clearSearch: Function;
  // eslint-disable-next-line no-unused-vars
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowSelectionModel: GridRowSelectionModel;
  setRowSelectionModel: Function;
};

const ACHTable = (props: ACHTableProps) => {
  const { data, rowSelectionModel, setRowSelectionModel } = props;

  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "date", sort: "desc" },
  ]);

  const handleSortModelChange = (newSortModel: GridSortModel) => {
    setSortModel(newSortModel);
  };

  const columns: GridColDef[] = React.useMemo<GridColDef[]>(
    () => [
      {
        field: "date",
        headerName: "ACH Date",
        minWidth: 180,
        sortable: true,
        valueFormatter: (params: GridValueFormatterParams) =>
          convertToLocalWithoutUTC(params.value).format("MM/DD/YYYY HH:mm:ss A"),
        headerClassName: "header-datagrid",
      },
      {
        field: "client",
        headerName: "Client",
        minWidth: 220,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "accountNumber",
        headerName: "Account Number",
        minWidth: 160,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "details",
        headerName: "ACH Info",
        minWidth: 450,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "amount",
        headerName: "Amount",
        minWidth: 180,
        sortable: false,
        headerClassName: "header-datagrid",
        valueGetter: (params: GridValueGetterParams) =>
          `${formatDollar(params.row.amount)}`,
      },
    ],
    []
  );

  return (
    <div className="data-table">
      <Box className="heading-row">
        <Typography variant="h5" component="h4">
          ACH
        </Typography>
      </Box>
      <DataGrid
        checkboxSelection
        rows={data}
        getRowId={(row) => row.id}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 50 },
          },
        }}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        pageSizeOptions={[10, 20, 30, 40, 50]}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
        }}
        rowSelectionModel={rowSelectionModel}
        className="datagrid"
      />
    </div>
  );
};

export default ACHTable;
